/*

  Implementated by Amit Sharma & Bryan Perez
  Dated : 11/26/2019

*/

import React, { useCallback, useState, Fragment } from "react";
import { Col, ModalBody, ModalFooter, Row, UncontrolledAlert } from 'reactstrap';
import { Field, reduxForm } from "redux-form";

import { UpwardLoadingButton, UpwardReduxInput, UpwardReduxSelect } from "ui";
import { freeRegistrationDetails } from "../../services/EmployerServices";
import FormValidators from "ui/FormValidators";
import { onlyNumbers } from "redux/form/normalize";
import { formatPhoneNumber } from "redux/form/format";
import { ThemeContext } from "../../context/ThemeContext";
import { validateCompanyName } from "corp-site/services/fusionValidators";

const numberOfHiresOptions = [
   { value: '1 to 9 jobs', label: '1 to 9 jobs' },
   { value: '10 to 49 jobs', label: '10 to 49 jobs' },
   { value: '50 to 99 jobs', label: '50 to 99 jobs' },
   { value: '100+ openings', label: '100+ openings' },
];


const minLength1 = FormValidators.minLength(1);

const EmployerDetailsForm = (props) => {

   const contextColor = React.useContext(ThemeContext);

   const [errorMessages, setErrorMessages] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   const handleSubmit = useCallback((formData) => {
      const { numberOfJobs, ...rest } = formData;

      freeRegistrationDetails({
         ...rest,
         terms: true,
         numberOfJobs: numberOfJobs && numberOfJobs.value
      }).subscribe(res => {
         if (res && res.outcome) {
            props.setCompany(rest.organization);
            props.onEmployerRegistrationFormSuccess();
         } else if (res && res.errorMsgs.length > 0) {
            setErrorMessages([...res.errorMsgs]);
            setIsLoading(false);
         } else {
            setErrorMessages(["An error occurred. Please try again later."]);
            setIsLoading(false);
         }
      }, err => console.log(err));
   }, [setErrorMessages, setIsLoading]);

   const handleValidation = useCallback((formData) => {
      const {
         organization,
      } = formData;

      setIsLoading(true);

      validateCompanyName(organization).subscribe(({ isCompanyNameBlacklisted }) => {
         let newErrorMessages = [];
         if (isCompanyNameBlacklisted) {
            newErrorMessages.push("Please enter a different company name.");
            setIsLoading(false);
            setErrorMessages(newErrorMessages);
         } else {
            handleSubmit(formData);
         }
      })

      // forkJoin([
      //    validateCompanyName(organization),
      //    validateFnameLnameEmail(fname, lname, "")
      // ]).subscribe(
      //    (
      //       [
      //          {
      //             isCompanyNameBlacklisted
      //          },
      //          {
      //             isFnameValid,
      //             isLnameValid,
      //          }
      //       ]
      //    ) => {
      //
      //       let newErrorMessages = [];
      //
      //       if (isCompanyNameBlacklisted) {
      //          newErrorMessages.push("Please enter a different company name.");
      //       }
      //
      //       if (!isFnameValid) {
      //          newErrorMessages.push("Please enter a valid first name.");
      //       }
      //
      //       if (!isLnameValid) {
      //          newErrorMessages.push("Please enter a valid last name.");
      //       }
      //
      //       if (newErrorMessages.length > 0) {
      //          setIsLoading(false);
      //          setErrorMessages(newErrorMessages);
      //       } else {
      //          handleSubmit(formData);
      //       }
      // });
   }, [setErrorMessages, setIsLoading, handleSubmit]);

   return (
      <Fragment>
         <div className="modal-header pt-3"><h5 className="modal-title" style={{ fontSize: "48px" }}>Account details</h5></div>
         <form onSubmit={props.handleSubmit(handleValidation)}>
            <ModalBody>
               {
                  errorMessages && errorMessages.length > 0 &&
                  <UncontrolledAlert color="danger" className="custom-alert-failure">
                     {
                        errorMessages.map(
                           (message, index) => (`${message} `)
                        )
                     }
                  </UncontrolledAlert>
               }

               <Row>
                  <Col xs={{ "size": 10, "offset": 1 }}>
                     <div className="form-group roundLgInput">
                        <Field type="text"
                           name="fname"
                           placeholder="First Name"
                           validate={[FormValidators.required]}
                           component={UpwardReduxInput} />
                     </div>
                     <div className="form-group roundLgInput">
                        <Field type="text"
                           name="lname"
                           placeholder="Last Name"
                           validate={[FormValidators.required]}
                           component={UpwardReduxInput} />
                     </div>
                     <div className="form-group roundLgInput">
                        <Field type="text"
                           name="phone"
                           placeholder="Phone Number"
                           validate={[FormValidators.required, FormValidators.number, FormValidators.phoneNumberLength]}
                           normalize={onlyNumbers}
                           format={formatPhoneNumber}
                           component={UpwardReduxInput} />
                     </div>
                     <div className="form-group roundLgInput">
                        <Field type="text"
                           name="organization"
                           placeholder="Company Name"
                           validate={[FormValidators.required, minLength1]}
                           component={UpwardReduxInput} />
                     </div>

                     <div className="form-group roundLgInput">
                        <Row form>
                           <Col sm={12}>
                              <Field component={UpwardReduxSelect}
                                 options={numberOfHiresOptions}
                                 validate={[FormValidators.required]}
                                 placeholder="Number Of Hires Per Year"
                                 name="numberOfJobs"
                                 isSearchable={false}
                                 />
                           </Col>
                        </Row>
                     </div>
                  </Col>
               </Row>
            </ModalBody>
            <ModalFooter>
               <Row>
                  <Col xs={{ "size": 10, "offset": 1 }} lg={{ "size": 6, "offset": 3 }}>
                     <UpwardLoadingButton
                        block
                        type="submit"
                        color="primary"
                        size="lg"
                        isLoading={isLoading}
                        className={"btn btn-xl btn-block btn-rounded btn-dark-" + contextColor}
                     >
                        <b>Continue</b>
                     </UpwardLoadingButton>
                  </Col>
               </Row>
            </ModalFooter>
         </form>
      </Fragment>
   )
};

export default reduxForm({
   form: 'employerRegistrationUserDetails'
})(EmployerDetailsForm);
